import React from 'react';

var UserInfo = ({ user }) => {

  var style = {
    display: 'inline-block',
    width: 48,
    height: 48,

    textAlign: 'center',
    overflow: 'hidden',
    fontSize: 14
  }

  var content = '';

  if (user.photoURL) {
    style.background = `url(${user.photoURL}) no-repeat center center`
    style.backgroundSize = 'cover';
  } else {
    content = user.name
  }

  return (<div style={style}>
    {content}
  </div>)
}

export default UserInfo;


// WEBPACK FOOTER //
// ./src/RollResults/UserInfo.js